import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Navbar from "./Navbar";
import Footer from "./Footer";
import LivingCircuit from "./LivingCircuit";
import CursorGlow from "./CursorGlow";

const Layout = () => {
  const location = useLocation();
  return (
    <div className="grain min-h-screen relative" data-testid="app-layout" style={{ backgroundColor: "var(--bg)", color: "var(--text)" }}>
      <LivingCircuit />
      <CursorGlow />
      <div className="content-layer">
        <Navbar />
        <AnimatePresence mode="wait">
          <motion.main
            key={location.pathname}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -14 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
          >
            <Outlet />
          </motion.main>
        </AnimatePresence>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
